import { useCallback, useMemo } from 'react';

import { useCrmObjectType } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';

import { UNFILED_ASSETS_ID } from '../constants/folders';

export default function useCurrentFolderId() {
  'use memo';
  const { folderId } = useCrmObjectType();

  const resolvedFolderId = useMemo(() => {
    if (!folderId) {
      return UNFILED_ASSETS_ID;
    }

    const intFolderId = Number(folderId);
    return intFolderId > 0 ? intFolderId : UNFILED_ASSETS_ID;
  }, [folderId]);

  return resolvedFolderId;
}

export function useSetCurrentFolderId() {
  'use memo';
  const { onSetFolderId } = useCrmObjectType();

  return useCallback(
    (folderId: string | number) => {
      onSetFolderId(folderId);
    },
    [onSetFolderId]
  );
}
